/**
 * inn_extended_data.ts - generated from backend INN catalogs.
 * Do not edit manually. Run: python scripts/generate_frontend_inn_data.py
 */

export const EXTENDED_INN_TO_CN: Record<string, string> = {
  "abatacept": "阿巴西普",
  "abemaciclib": "阿贝西利",
  "abi_h0731": "ABI-H0731",
  "abiraterone": "阿比特龙",
  "abrocitinib": "阿布昔替尼",
  "acalabrutinib": "阿卡替尼",
  "acetaminophen": "对乙酰氨基酚",
  "acitretin": "阿维A",
  "aclidinium": "阿地溴铵",
  "acyclovir": "阿昔洛韦",
  "adagrasib": "阿达格拉西布",
  "adalimumab": "阿达木单抗",
  "adapalene": "阿达帕林",
  "ado_trastuzumab_emtansine": "T-DM1",
  "aducanumab": "阿杜卡努单抗",
  "afatinib": "阿法替尼",
  "aflibercept": "阿柏西普",
  "agomelatine": "阿戈美拉汀",
  "albiglutide": "阿必鲁肽",
  "alectinib": "阿来替尼",
  "alemtuzumab": "阿仑单抗",
  "alendronate": "阿仑膦酸",
  "alfuzosin": "阿夫唑嗪",
  "alg_020579": "ALG-020579",
  "alirocumab": "阿利库单抗",
  "allopurinol": "别嘌醇",
  "almonertinib": "阿美替尼",
  "alogliptin": "阿格列汀",
  "alpelisib": "阿培利司",
  "alprazolam": "阿普唑仑",
  "ambrisentan": "安立生坦",
  "amiselimod": "阿米西莫德",
  "amivantamab": "埃万妥单抗",
  "amlodipine": "氨氯地平",
  "amoxicillin": "阿莫西林",
  "amx0035": "AMX0035",
  "amylase": "淀粉酶",
  "anakinra": "阿那白滞素",
  "anifrolumab": "阿尼弗鲁单抗",
  "aniracetam": "茴拉西坦",
  "anlotinib": "安罗替尼",
  "apalutamide": "阿帕鲁胺",
  "apatinib": "阿帕替尼",
  "apixaban": "阿哌沙班",
  "apomorphine": "阿扑吗啡",
  "apremilast": "阿普斯特",
  "aripiprazole": "阿立哌唑",
  "armodafinib": "阿莫达非尼",
  "artemether_lumefantrine": "蒿甲醚/苯芴醇",
  "artesunate_amodiaquine": "青蒿琥酯/阿莫地喹",
  "ascorbic acid": "抗坏血酸",
  "asenapine": "阿塞那平",
  "asunaprevir": "阿舒那韦",
  "atezolizumab": "阿替利珠单抗",
  "atogepant": "阿托吉潘",
  "atomoxetine": "托莫西汀",
  "atorvastatin": "阿托伐他汀",
  "avacopan": "阿伐可泮",
  "avanafil": "阿伐那非",
  "avapritinib": "阿伐普替尼",
  "avatrombopag": "阿伐曲泊帕",
  "avelumab": "阿维鲁单抗",
  "axicabtagene_ciloleucel": "axi-cel",
  "axitinib": "阿昔替尼",
  "azelaic acid": "壬二酸",
  "azilsartan": "阿齐沙坦",
  "azithromycin": "阿奇霉素",
  "aztreonam": "氨曲南",
  "aztreonam_avibactam": "氨曲南/阿维巴坦",
  "aztreonam_inhalation": "吸入用氨曲南",
  "baloxavir_marboxil": "玛巴洛沙韦",
  "balsalazide": "巴柳氮",
  "balversa": "Balversa",
  "baricitinib": "巴瑞替尼",
  "bcg": "卡介苗",
  "bebtelovimab": "Bebtelovimab",
  "bedaquiline": "贝达喹啉",
  "belantamab_mafodotin": "Blenrep",
  "belimumab": "贝利木单抗",
  "belinostat": "贝利司他",
  "belzutifan": "贝尔祖替凡",
  "bempedoic_acid": "贝派地酸",
  "benidipine": "贝尼地平",
  "benralizumab": "本瑞利珠单抗",
  "benzbromarone": "苯溴马隆",
  "benzoyl_peroxide": "过氧化苯甲酰",
  "besifovir_dipivoxil": "贝西福韦",
  "betamethasone": "倍他米松",
  "betibeglogene_autotemcel": "Zynteglo",
  "bevacizumab": "贝伐珠单抗",
  "bexarotene": "贝沙罗汀",
  "bezafibrate": "苯扎贝特",
  "bictegravir": "比克替拉韦",
  "bimatoprost": "贝美前列素",
  "bimekizumab": "比美珠单抗",
  "binimetinib": "比美替尼",
  "bismuth_subsalicylate": "碱式水杨酸铋",
  "bisoprolol": "比索洛尔",
  "bosentan": "波生坦",
  "brexpiprazole": "依匹哌唑",
  "brexucabtagene_autoleucel": "tecarta",
  "brigatinib": "布吉他滨",
  "brinzolamide": "布林佐胺",
  "brivaracetam": "布瓦西坦",
  "brodalumab": "布达鲁单抗",
  "budesonide": "布地奈德",
  "budesonide_ibd": "布地奈德(IBD)",
  "budesonide_iga": "布地奈德肠溶胶囊(IgA肾病)",
  "buformin": "丁双胍",
  "bulevirtide": "布来韦肽",
  "bupropion": "安非他酮",
  "bupropion_naltrexone": "安非他酮naltrexone",
  "buspirone": "丁螺环酮",
  "cabazitaxel": "卡巴他赛",
  "cabotegravir": "卡博特韦",
  "cabozantinib": "卡博替尼",
  "cadonilimab": "卡度尼利单抗",
  "calcipotriol": "卡泊三醇",
  "calcitriol": "骨化三醇",
  "camrelizumab": "卡瑞利珠单抗",
  "canagliflozin": "卡格列净",
  "canagliflozin_metformin": "卡格列净二甲双胍",
  "canakinumab": "卡纳单抗",
  "candesartan": "坎地沙坦",
  "cangrelor": "坎格瑞洛",
  "capmatinib": "卡马替尼",
  "captopril": "卡托普利",
  "carbamazepine": "卡马西平",
  "carboplatin": "卡铂",
  "cariprazine": "卡利拉嗪",
  "casgevy": "Casgevy",
  "casirivimab_imdevimab": "REGEN-COV",
  "cefiderocol": "头孢地尔",
  "cefotaxime": "头孢克肟",
  "ceftazidime_avibactam": "头孢他啶/阿维巴坦",
  "ceftolozane_tazobactam": "头孢洛扎/他唑巴坦",
  "ceftriaxone": "头孢曲松",
  "celecoxib": "塞来昔布",
  "cemiplimab": "西米普利单抗",
  "cenicriviroc": "塞尼西罗韦",
  "cenobamate": "辛诺巴莫特",
  "ceritinib": "色瑞替尼",
  "certolizumab": "赛妥珠单抗",
  "certolizumab_pegol": "赛妥珠单抗酯",
  "chenodeoxycholic_acid": "鹅去氧胆酸",
  "chlorpromazine": "氯丙嗪",
  "cilnidipine": "西尼地平",
  "ciltacabtagene_autoleucel": "Carvykti",
  "ciprofibrate": "环丙贝特",
  "ciprofloxacin": "环丙沙星",
  "cisplatin": "顺铂",
  "citalopram": "西酞普兰",
  "cladribine": "克拉屈滨",
  "clindamycin": "克林霉素",
  "clobetasol": "氯倍他索",
  "clonazepam": "氯硝西泮",
  "clonidine": "可乐定",
  "clopidogrel": "氯吡格雷",
  "clozapine": "氯氮平",
  "colistimethate_inhalation": "吸入用粘菌素甲磺酸钠",
  "coluracetam": "科尔鲁西坦",
  "copanlisib": "库潘尼西",
  "crenolanib": "克雷诺拉尼",
  "crisaborole": "克立硼罗",
  "crizanlizumab": "克立赞珠单抗",
  "crizotinib": "克唑替尼",
  "crofelemer": "克罗非莫",
  "cyclosporine": "环孢素",
  "cyproterone": "醋酸环丙孕酮",
  "cysteamine_bitartrate": "半胱胺比特塔尔",
  "dabigatran": "达比加群",
  "dabrafenib": "达拉非尼",
  "daclatasvir": "达卡他韦",
  "dacomitinib": "达克替尼",
  "damoctocog_alfa_pegol": "达莫库珠α聚乙二醇",
  "dapagliflozin": "达格列净",
  "dapagliflozin_metformin": "达格列净二甲双胍",
  "dapsone": "氨苯砜",
  "daridorexant": "达利度雷生",
  "darifenacin": "达非那新",
  "darolutamide": "达洛鲁胺",
  "dasabuvir_ombitasvir_paritapritonavir": "达沙布韦/奥比他韦/帕利瑞韦/利托那韦",
  "dasatinib": "达沙替尼",
  "datopotamab_deruxtecan": "Dato-DXd",
  "degarelix": "地加瑞克",
  "delafloxacin": "德拉沙星",
  "delamanid": "德拉马尼",
  "delgocitinib": "德尔戈替尼",
  "denosumab": "地舒单抗",
  "desmopressin": "去氨加压素",
  "desonide": "地奈德",
  "deucravacitinib": "德卡伐替尼",
  "dexamethasone": "地塞米松",
  "dexlansoprazole": "右兰索拉唑",
  "diazepam": "地西泮",
  "diclofenac": "双氯芬酸",
  "dihydroartemisinin_piper": "双氢青蒿素/哌喹",
  "diltiazem": "地尔硫卓",
  "dimethyl_fumarate": "富马酸二甲酯",
  "diphenoxylate_atropine": "地芬诺酯/阿托品",
  "diroximel_fumarate": "迪罗西麦富马酸盐",
  "docetaxel": "多西他赛",
  "donafenib": "多纳非尼",
  "donanemab": "多纳单抗",
  "donepezil": "多奈哌齐",
  "doravirine": "多拉韦林",
  "dornase_alfa": "链道酶α",
  "dorzolamide": "多佐胺",
  "dostarlimab": "多塔利单抗",
  "dovitinib": "多韦替尼",
  "doxazosin": "多沙唑嗪",
  "doxorubicin": "多柔比星",
  "doxycycline": "多西环素",
  "dronedarone": "决奈达隆",
  "dulaglutide": "度拉糖肽",
  "duloxetine": "度洛西汀",
  "dupilumab": "度普利尤单抗",
  "durvalumab": "度伐利尤单抗",
  "dutasteride": "度他雄胺",
  "duvelisib": "度恩利西",
  "eculizumab": "依库珠单抗",
  "edaravone": "依达拉奉",
  "edoxaban": "艾多沙班",
  "efgartigimod": "伊夫加替莫德",
  "efmoroctocog_alfa": "艾美赛珠α",
  "elbasvir": "艾尔巴韦",
  "elbasvir_grazoprevir": "艾尔巴韦/格拉瑞韦",
  "elexacaftor": "依来卡托",
  "elexacaftor_tezacaftor_ivacaftor": "Trikafta/Kaftrio",
  "elobixibat": "艾洛昔巴特",
  "eltrombopag": "艾曲波帕",
  "eluxadoline": "依卢多林",
  "emicizumab": "艾美赛珠单抗",
  "empagliflozin": "恩格列净",
  "empagliflozin_metformin": "恩格列净二甲双胍",
  "enalapril": "依那普利",
  "enasidenib": "恩西地平",
  "encorafenib": "恩考芬尼",
  "enfortumab_vedotin": "Padcev",
  "enoxaparin": "依诺肝素",
  "ensartinib": "恩沙替尼",
  "entacapone": "恩他卡朋",
  "entrectinib": "恩曲替尼",
  "envafolimab": "恩沃利单抗",
  "enzalutamide": "恩杂鲁胺",
  "epirubicin": "表柔比星",
  "epoprostenol": "依前列醇",
  "eprosartan": "依普沙坦",
  "eptinezumab": "埃普奈珠单抗",
  "eravacycline": "依拉环素",
  "erdafitinib": "厄达替尼",
  "erenumab": "厄瑞奴单抗",
  "erlotinib": "厄洛替尼",
  "ertugliflozin": "艾托格列净",
  "ertugliflozin_metformin": "艾托格列净二甲双胍",
  "erythromycin": "红霉素",
  "escitalopram": "艾司西酞普兰",
  "esketamine": "艾司氯胺酮",
  "eslicarbazepine": "艾司利卡西平",
  "esomeprazole": "艾司奥美拉唑",
  "estazolam": "艾司唑仑",
  "estradiol": "雌二醇",
  "estramustine": "雌莫司汀",
  "eszopiclone": "右佐匹克隆",
  "etanercept": "依那西普",
  "etoricoxib": "依托考昔",
  "etranacogene_deparvovec": "Hemgenix",
  "etrasimod": "埃曲西莫德",
  "everolimus": "依维莫司",
  "evinacumab": "埃维纳库单抗",
  "evogliptin": "依沃列汀",
  "evolocumab": "依洛尤单抗",
  "exenatide": "艾塞那肽",
  "fasoracetam": "法索西坦",
  "favipiravir": "法匹拉韦",
  "febuxostat": "非布司他",
  "fedratinib": "非卓替尼",
  "felodipine": "非洛地平",
  "fenfluramine": "芬氟拉明",
  "fenofibrate": "非诺贝特",
  "ferulic acid": "阿魏酸",
  "fesoterodine": "非索罗定",
  "fidanacogene_elaparvovec": "fidanacogene elaparvovec",
  "filgotinib": "非戈替尼",
  "finasteride": "非那雄胺",
  "fingolimod": "芬戈莫德",
  "fluocinolone": "氟轻松",
  "fluoxetine": "氟西汀",
  "flutamide": "氟他胺",
  "fluticasone": "氟替卡松",
  "fluvastatin": "氟伐他汀",
  "foretinib": "福替尼",
  "formoterol": "福莫特罗",
  "fosinopril": "福辛普利",
  "foslevodopa": "福斯左多巴",
  "fosmanogepix": "福斯马诺匹克司",
  "fostamatinib": "福他替尼",
  "fotemustine": "福莫司汀",
  "fremanezumab": "弗瑞奈珠单抗",
  "fruquintinib": "呋喹替尼",
  "furmonertinib": "伏美替尼",
  "futibatinib": "福巴替尼",
  "gabapentin": "加巴喷丁",
  "gabapentin_enacarbil": "加巴喷丁酯",
  "galantamine": "加兰他敏",
  "galcanezumab": "加卡奈珠单抗",
  "ganaxolone": "加奈索龙",
  "garadacimab": "加拉达昔单抗",
  "gefitinib": "吉非替尼",
  "gemcitabine": "吉西他滨",
  "gemfibrozil": "吉非罗齐",
  "gemigliptin": "吉格列汀",
  "gergliptin": "格列列汀",
  "gilteritinib": "吉瑞替尼",
  "glecaprevir": "格卡瑞韦",
  "glecaprevir_pibrentasvir": "格卡瑞韦/哌仑他韦",
  "glibenclamide": "格列本脲",
  "gliclazide": "格列齐特",
  "glimepiride": "格列美脲",
  "glimepiride_metformin": "格列美脲二甲双胍",
  "glimepirone": "格列美醇",
  "glipizide": "格列吡嗪",
  "gliquidone": "格列喹酮",
  "glyburide": "格列本脲",
  "glyburide_metformin": "格列本脲二甲双胍",
  "glycolic acid": "乙醇酸",
  "glycopyrronium": "格隆溴铵",
  "golimumab": "戈利木单抗",
  "goserelin": "戈舍瑞林",
  "grazoprevir": "格拉瑞韦",
  "guanfacine": "胍法辛",
  "guselkumab": "古塞奇尤单抗",
  "haloperidol": "氟哌啶醇",
  "heparin": "肝素",
  "hetrombopag": "海曲泊帕",
  "histrelin": "组胺瑞林",
  "hydergine": "喜得镇",
  "hydrochlorothiazide": "氢氯噻嗪",
  "hydrocortisone": "氢化可的松",
  "hydroxyzine": "羟嗪",
  "ibrexafungerp": "艾瑞卡芬格匹",
  "ibrutinib": "伊布替尼",
  "ibuprofen": "布洛芬",
  "idecabtagene_vicleucel": "Abecma",
  "idecel": "idecel",
  "idelalisib": "艾代拉里斯",
  "iloperidone": "伊潘立酮",
  "iloprost": "伊洛前列素",
  "imatinib": "伊马替尼",
  "imidapril": "咪达普利",
  "imipenem_relebactam": "亚胺培南/瑞来巴坦",
  "inclisiran": "英克西兰",
  "infliximab": "英夫利西单抗",
  "interferon_alfa": "干扰素α",
  "interleukin_2": "白细胞介素-2",
  "ipilimumab": "伊匹木单抗",
  "ipragliflozin": "伊普格列净",
  "ipratropium": "异丙托溴铵",
  "irbesartan": "厄贝沙坦",
  "islatravir": "伊斯特拉韦",
  "isotretinoin": "异维A酸",
  "isradipine": "伊拉地平",
  "istradefylline": "伊斯特拉德菲",
  "ivabradine": "伊伐布雷定",
  "ivacaftor": "依伐卡托",
  "ivekizumab": "伊维珠单抗",
  "ivosidenib": "艾伏尼布",
  "ixazomib": "伊沙佐米",
  "ixekizumab": "依奇珠单抗",
  "jnj_6379": "JNJ-6379",
  "ketamine": "氯胺酮",
  "kojic acid": "曲酸",
  "l_glutamine_powder": "L-谷氨酰胺口服粉剂",
  "lacidipine": "拉西地平",
  "lacosamide": "拉考酰胺",
  "lactic acid": "乳酸",
  "ladostigil": "拉多斯蒂吉",
  "lamotrigine": "拉莫三嗪",
  "lanifibranor": "兰尼布诺",
  "laninamivir": "拉尼纳米韦",
  "lansoprazole": "兰索拉唑",
  "lapatinib": "拉帕替尼",
  "larotrectinib": "拉罗替尼",
  "lasmiditan": "拉斯米地坦",
  "latanoprost": "拉坦前列素",
  "lebrikizumab": "来布里珠单抗",
  "lecanemab": "勒卡尼单抗",
  "ledipasvir": "来迪派韦",
  "ledipasvir_sofosbuvir": "来迪派韦/索磷布韦",
  "lefamulin": "来法米林",
  "lemborexant": "莱博雷生",
  "lenacapavir": "伦卡帕韦",
  "lenalidomide": "来那度胺",
  "lenvatinib": "乐伐替尼",
  "lercanidipine": "乐卡地平",
  "leuprolide": "亮丙瑞林",
  "levetiracetam": "左乙拉西坦",
  "levofloxacin": "左氧氟沙星",
  "levofloxacin_inhalation": "吸入用左氧氟沙星",
  "levomilnacipran": "左美丙米嗪",
  "levothyroxine": "左甲状腺素",
  "linaclotide": "利那洛肽",
  "linagliptin": "利格列汀",
  "linagliptin_metformin": "利格列汀二甲双胍",
  "linezolid": "利奈唑胺",
  "linperlisib": "林普利西",
  "lipase": "脂肪酶",
  "liraglutide": "利拉鲁肽",
  "liraglutide_weight": "利拉鲁肽注射液(减重)",
  "lisdexamfetamine": "赖右苯丙胺",
  "lisinopril": "赖诺普利",
  "lisocabtagene_maraleucel": "liso-cel",
  "lithium": "锂盐",
  "lixisenatide": "利西拉来",
  "lodenafil": "罗地那非",
  "lonapegsomatropin": "洛那帕生长素",
  "loncastuximab_tesirine": "Zynlonta",
  "loperamide": "洛哌丁胺",
  "lorazepam": "劳拉西泮",
  "lorlatinib": "劳拉替尼",
  "losartan": "氯沙坦",
  "lovastatin": "洛伐他汀",
  "lu177_vipivotide_tetraxetan": "Lutathera",
  "lubiprostone": "鲁比前列酮",
  "lumacaftor": "鲁马卡托",
  "lumateperone": "卢美哌隆",
  "luseogliflozin": "卢塞格列净",
  "luspatercept": "罗特西普",
  "lyfgenia": "Lyfgenia",
  "macitentan": "马昔腾坦",
  "mandelic acid": "扁桃酸",
  "manidipine": "曼尼地平",
  "manogepix": "马诺匹克司",
  "maralixibat": "马利昔巴特",
  "margetuximab": "玛格妥昔单抗",
  "marstacimab": "马斯塔昔单抗",
  "maxacalcitol": "马克沙钙醇",
  "meloxicam": "美洛昔康",
  "memantine": "美金刚",
  "mepolizumab": "美泊利单抗",
  "meropenem_vaborbactam": "美罗培南/法硼巴坦",
  "mesalamine": "美沙拉嗪",
  "metformin": "二甲双胍",
  "methotrexate": "甲氨蝶呤",
  "methylnaltrexone": "甲基纳曲酮",
  "methylprednisolone": "甲泼尼龙",
  "metoclopramide": "甲氧氯普胺",
  "metronidazole": "甲硝唑",
  "midostaurin": "米哚妥林",
  "milnacipran": "米那普仑",
  "minocycline": "米诺环素",
  "mirabegron": "米拉贝隆",
  "mirikizumab": "米瑞珠单抗",
  "mirodenafil": "米罗地那非",
  "mirogabalin": "美洛加巴林",
  "mirtazapine": "米氮平",
  "mirvetuximab_soravtansine": "Elahere",
  "mitomycin_c": "丝裂霉素C",
  "mitoxantrone": "米托蒽醌",
  "mobocertinib": "莫博赛替尼",
  "modafinil": "莫达非尼",
  "molnupiravir": "莫诺拉韦",
  "mometasone": "糠酸莫米松",
  "montelukast": "孟鲁司特",
  "moxifloxacin": "莫西沙星",
  "mycophenolate": "吗替麦考酚",
  "nadofaragene_firenadenovec": "Adstiladrin",
  "nafarelin": "那法瑞林",
  "naldemedine": "纳地美定",
  "naloxegol": "纳洛西格",
  "naproxen": "萘普生",
  "natalizumab": "那他珠单抗",
  "nefecon": "耐福康",
  "nefiracetam": "奈非西坦",
  "nemolizumab": "奈莫利珠单抗",
  "neratinib": "奈拉替尼",
  "nicardipine": "尼卡地平",
  "nifedipine": "硝苯地平",
  "nilotinib": "尼洛替尼",
  "nintedanib": "尼达尼布",
  "niraparib": "尼拉帕利",
  "nirmatrelvir_ritonavir": "奈玛特韦/利托那韦(Paxlovid)",
  "nitrendipine": "尼群地平",
  "nivolumab": "纳武利尤单抗",
  "noopept": "诺匹司坦",
  "obeticholic_acid": "奥贝胆酸",
  "obinutuzumab": "奥妥珠单抗",
  "ocrelizumab": "奥瑞珠单抗",
  "odevixibat": "奥德维昔巴特",
  "ofatumumab": "奥法木单抗",
  "olanzapine": "奥氮平",
  "olaparib": "奥拉帕利",
  "olmesartan": "奥美沙坦",
  "olorofim": "奥洛罗芬",
  "olsalazine": "奥沙拉嗪",
  "olutasidenib": "奥鲁塔西地尼",
  "omadacycline": "奥马环素",
  "omalizumab": "奥马珠单抗",
  "ombitasvir": "奥比他韦",
  "ombitasvir_paritaprevir_ritonavir": "奥比他韦/帕利瑞韦/利托那韦",
  "omecamtiv_mecarbil": "奥美卡替美卡比",
  "omega_3_acid_ethyl_esters": "ω-3脂肪酸乙酯",
  "omeprazole": "奥美拉唑",
  "onabotulinumtoxina": "肉毒素A(Botox膀胱注射)",
  "ondansetron": "昂丹司琼",
  "opelconazole": "奥佩康唑",
  "opicapone": "奥皮卡朋",
  "opipramol": "奥匹哌醇",
  "orelabrutinib": "奥雷巴替尼",
  "orlistat": "奥利司他",
  "oseltamivir": "奥司他韦",
  "osimertinib": "奥希替尼",
  "oxcarbazepine": "奥卡西平",
  "oxiracetam": "奥拉西坦",
  "oxybutynin": "奥昔布宁",
  "ozanimod": "奥扎尼莫德",
  "pacritinib": "帕克里替尼",
  "palbociclib": "哌柏西利",
  "paliperidone": "帕利哌酮",
  "pancrelipase": "胰脂肪酶",
  "panobinostat": "帕比司他",
  "pantoprazole": "泮托拉唑",
  "paracetamol": "对乙酰氨基酚",
  "paritaprevir": "帕利瑞韦",
  "paroxetine": "帕罗西汀",
  "parsaclisib": "帕萨克利西",
  "patritumab_deruxtecan": "HER3-DXd",
  "pazopanib": "帕唑帕尼",
  "peficitinib": "佩费替尼",
  "pemafibrate": "培马贝特",
  "pemazyre": "佩米替尼",
  "pembrolizumab": "帕博利珠单抗",
  "pemigatinib": "培米替尼",
  "peramivir": "帕拉米韦",
  "perampanel": "吡仑帕奈",
  "perindopril": "培哚普利",
  "peripherally_acting_mu_opioid_antagonists": "外周作用μ受体拮抗剂",
  "pertuzumab": "帕妥珠单抗",
  "phenformin": "苯乙双胍",
  "phentermine_topiramate": "phentermine托吡酯",
  "phenylpiracetam": "苯基吡拉西坦",
  "phenytoin": "苯妥英",
  "pibrentasvir": "哌仑他韦",
  "pimavanserin": "匹莫范色林",
  "pimecrolimus": "吡美莫司",
  "pioglitazone": "吡格列酮",
  "pioglitazone_metformin": "吡格列酮二甲双胍",
  "piracetam": "吡拉西坦",
  "pirfenidone": "吡非尼酮",
  "pirtobrutinib": "匹妥布鲁替尼",
  "pitavastatin": "匹伐他汀",
  "plecanatide": "普卡那肽",
  "pluvicto": "Pluvicto",
  "pomalidomide": "泊马度胺",
  "ponesimod": "波内西莫德",
  "pralsetinib": "普拉替尼",
  "pramipexole": "普拉克索",
  "pramiracetam": "普拉西坦",
  "prasugrel": "普拉格雷",
  "pravastatin": "普伐他汀",
  "prazosin": "哌唑嗪",
  "prednicarbate": "泼尼卡酯",
  "prednisolone": "泼尼松龙",
  "prednisone": "泼尼松",
  "pregabalin": "普瑞巴林",
  "pretomanid": "普托马尼",
  "progesterone": "黄体酮",
  "prolgolimab": "普罗利珠单抗",
  "propiverine": "普罗维韦",
  "protease": "蛋白酶",
  "prucalopride": "普芦卡必利",
  "pyronaridine_artesunate": "磷酸萘酚喹/青蒿琥酯",
  "pyrotinib": "吡咯替尼",
  "quetiapine": "喹硫平",
  "quinapril": "喹那普利",
  "quizartinib": "奎扎替尼",
  "rabeprazole": "雷贝拉唑",
  "racecadotril": "消旋卡多曲",
  "radium_223": "镭223",
  "ramelteon": "雷美替胺",
  "ramipril": "雷米普利",
  "ramucirumab": "雷莫芦单抗",
  "rasagiline": "雷沙吉兰",
  "ravulizumab": "拉武利珠单抗",
  "reboxetine": "瑞波西汀",
  "regdanvimab": "Regdanvimab",
  "regorafenib": "瑞戈非尼",
  "reldesemtiv": "雷尔德塞姆替夫",
  "relugolix": "瑞卢戈利",
  "remdesivir": "瑞德西韦",
  "remogliflozin": "雷莫格列净",
  "repotrectinib": "瑞普替尼",
  "reslizumab": "瑞利珠单抗",
  "resmetirom": "雷斯美替罗",
  "retigabine": "瑞替加宾",
  "revefenacin": "瑞维非宁",
  "rezafungin": "瑞扎芬净",
  "ribavirin": "利巴韦林",
  "ribociclib": "瑞博西利",
  "rifaximin": "利福昔明",
  "rilpivirine": "利匹韦林",
  "riluzole": "利鲁唑",
  "rimegepant": "瑞美吉潘",
  "riociguat": "利奥西呱",
  "ripretinib": "瑞派替尼",
  "risankizumab": "瑞赞珠单抗",
  "risedronate": "利塞膦酸",
  "risperidone": "利培酮",
  "ritonavir": "利托那韦",
  "rituximab": "利妥昔单抗",
  "rivaroxaban": "利伐沙班",
  "rivastigmine": "利斯的明",
  "roluperidone": "罗鲁培酮",
  "romidepsin": "罗米地辛",
  "romiplostim": "罗米司亭",
  "ropinirole": "罗匹尼罗",
  "rosiglitazone": "罗格列酮",
  "rosiglitazone_metformin": "罗格列酮二甲双胍",
  "rosuvastatin": "瑞舒伐他汀",
  "rotigotine": "罗替戈汀",
  "rozanolixizumab": "罗卓利珠单抗",
  "rucaparib": "卢卡帕利",
  "rufinamide": "卢非酰胺",
  "ruxolitinib": "芦可替尼",
  "sacituzumab_govitecan": "Trodelvy",
  "sacubitril": "沙库巴曲",
  "sacubitril_valsartan": "沙库巴曲缬沙坦",
  "safinamide": "沙芬酰胺",
  "salbutamol": "沙丁胺醇",
  "salicylic acid": "水杨酸",
  "salmeterol": "沙美特罗",
  "sarecycline": "sarecycline",
  "sarilumab": "沙利鲁单抗",
  "satralizumab": "萨特利珠单抗",
  "savolitinib": "赛沃替尼",
  "saxagliptin": "沙格列汀",
  "secukinumab": "苏金单抗",
  "selegiline": "司来吉兰",
  "selexipag": "赛乐西帕",
  "selinexor": "塞利尼索",
  "selitrectinib": "塞利曲替尼",
  "selpercatinib": "塞尔帕替尼",
  "semaglutide": "司美格鲁肽",
  "semaglutide_injection": "司美格鲁肽注射液",
  "semaglutide_nash": "司美格鲁肽(NASH)",
  "serplulimab": "赛帕利单抗",
  "sertraline": "舍曲林",
  "setmelanotide": "司美拉诺肽",
  "sildenafil": "西地那非",
  "sildenafil_pah": "西地那非(肺高压)",
  "silodosin": "西洛多辛",
  "simvastatin": "辛伐他汀",
  "sintilimab": "信迪利单抗",
  "siponimod": "西波尼莫德",
  "sirolimus": "西罗莫司",
  "sitagliptin": "西格列汀",
  "sodium_phenylbutyrate_taurursodiol": "苯丁酸钠牛磺熊去氧胆酸",
  "sofosbuvir": "索磷布韦",
  "sofosbuvir_velpatasvir": "索磷布韦/维帕他韦",
  "sofosbuvir_velpatasvir_voxilaprevir": "索磷布韦/维帕他韦/ voxilaprevir",
  "solifenacin": "索利那新",
  "solriamfetol": "索利亚莫非",
  "somapacitan": "索马帕太坦",
  "somatrogon": "索马曲甘",
  "sorafenib": "索拉非尼",
  "sotorasib": "索托拉西布",
  "sotrovimab": "Sotrovimab",
  "spesolimab": "斯佩利珠单抗",
  "stiripentol": "司替戊醇",
  "sugemalimab": "舒格利单抗",
  "sulfasalazine": "柳氮磺吡啶",
  "sunitinib": "舒尼替尼",
  "sunvozertinib": "舒沃替尼",
  "surufatinib": "索凡替尼",
  "sutezolid": "苏泰唑烷",
  "suvorexant": "苏沃雷生",
  "tacalcitol": "他卡西醇",
  "tacrolimus": "他克莫司",
  "tadalafil": "他达拉非",
  "tadalafil_pah": "他达拉非(肺高压)",
  "tafenoquine": "他非诺喹",
  "talazoparib": "他拉唑帕利",
  "tamsulosin": "坦索罗辛",
  "tasimelteon": "他司美琼",
  "taspoglutide": "他司鲁肽",
  "tazarotene": "他扎罗汀",
  "tazemetostat": "他泽美司他",
  "telisotuzumab_vedotin": "Teliso-V",
  "telmisartan": "替米沙坦",
  "telmisartan_amlodipine": "替米沙坦氨氯地平",
  "telmisartan_hydrochlorothiazide": "替米沙坦氢氯噻嗪",
  "temsirolimus": "替西罗莫司",
  "tenapanor": "替纳帕诺",
  "teneligliptin": "替尼格列汀",
  "tenofovir_alafenamide": "替诺福韦艾拉酚胺",
  "tepotinib": "特泊替尼",
  "teprotumumab": "替妥木单抗",
  "terazosin": "特拉唑嗪",
  "teriflunomide": "特立氟胺",
  "testosterone": "睾酮",
  "tezacaftor": "特扎卡托",
  "tezacaftor_ivacaftor": "特扎卡托/依伐卡托",
  "tezepelumab": "特泽鲁单抗",
  "thiotepa": "塞替派",
  "tianeptine": "硫必利",
  "ticagrelor": "替格瑞洛",
  "tildrakizumab": "提德拉珠单抗",
  "timolol": "噻吗洛尔",
  "tiotropium": "噻托溴铵",
  "tirabrutinib": "替拉布鲁替尼",
  "tirzepatide": "Mounjaro",
  "tisagenlecleucel": "tisagenlecleucel",
  "tislelizumab": "替雷利珠单抗",
  "tisotumab_vedotin": "Tivdak",
  "tivantinib": "替万替尼",
  "tivozanib": "蒂沃扎尼",
  "tixagevimab_cilgavimab": "Evusheld",
  "tobramycin_inhalation": "吸入用妥布霉素",
  "tocilizumab": "托珠单抗",
  "tofacitinib": "托法替尼",
  "tofersen": "托夫生",
  "tofogliflozin": "托格列净",
  "tolterodine": "托特罗定",
  "topiramate": "托吡酯",
  "toripalimab": "特瑞普利单抗",
  "tralokinumab": "曲罗金单抗",
  "trametinib": "曲美替尼",
  "trandolapril": "群多普利",
  "tranexamic acid": "氨甲环酸",
  "trastuzumab": "曲妥珠单抗",
  "trastuzumab_deruxtecan": "Enhertu",
  "trazodone": "曲唑酮",
  "treprostinil": "曲前列素",
  "tretinoin": "维A酸",
  "triamcinolone": "曲安奈德",
  "trilaciclib": "曲拉西利",
  "triptorelin": "曲普瑞林",
  "trospium_chloride": "曲司氯铵",
  "tucatinib": "图卡替尼",
  "ubrogepant": "乌布吉潘",
  "udenafil": "乌地那非",
  "ulotaront": "Ulotaront",
  "umbralisib": "乌布利西",
  "umeclidinium": "乌美溴铵",
  "upadacitinib": "乌帕替尼",
  "ursodeoxycholic_acid": "熊去氧胆酸",
  "ustekinumab": "乌司奴单抗",
  "valacyclovir": "伐昔洛韦",
  "valoctocog_roxall": "ValRoxo",
  "valproate": "丙戊酸盐",
  "valproic_acid": "丙戊酸",
  "valsartan": "缬沙坦",
  "vardenafil": "伐地那非",
  "vardenafil_pah": "伐地那非(肺高压)",
  "vedolizumab": "维多利珠单抗",
  "velpatasvir": "维帕他韦",
  "venetoclax": "维奈克拉",
  "venlafaxine": "文拉法辛",
  "vericiguat": "维利西呱",
  "vernakalant": "维纳卡兰特",
  "vibegron": "维贝格隆",
  "vilazodone": "维拉佐酮",
  "vildagliptin": "维格列汀",
  "viloxazine": "维洛沙嗪",
  "vinblastine": "长春碱",
  "vir_2218": "VIR-2218",
  "voclosporin": "伏环孢素",
  "vorinostat": "伏立诺他",
  "vortioxetine": "沃替西汀",
  "voxelotor": "沃塞洛托",
  "voxilaprevir": "沃昔拉韦",
  "warfarin": "华法林",
  "xanomeline": "呫诺美林",
  "xanomeline_trospium_chloride": "呫诺美林曲司氯铵",
  "zanimivab": "扎尼单抗",
  "zanubrutinib": "泽布替尼",
  "zavegepant": "扎维吉潘",
  "zilucoplan": "祖鲁库单抗",
  "ziprasidone": "齐拉西酮",
  "zoledronate": "唑来膦酸",
  "zolpidem": "唑吡坦",
  "zonisamide": "唑尼沙胺",
  "zopiclone": "佐匹克隆"
};

export const EXTENDED_CN_TO_INN: Record<string, string> = {
  "ABI-H0731": "abi_h0731",
  "ALG-020579": "alg_020579",
  "AMX0035": "amx0035",
  "Abecma": "idecabtagene_vicleucel",
  "Adstiladrin": "nadofaragene_firenadenovec",
  "Balversa": "balversa",
  "Bebtelovimab": "bebtelovimab",
  "Blenrep": "belantamab_mafodotin",
  "Carvykti": "ciltacabtagene_autoleucel",
  "Casgevy": "casgevy",
  "Dato-DXd": "datopotamab_deruxtecan",
  "Elahere": "mirvetuximab_soravtansine",
  "Enhertu": "trastuzumab_deruxtecan",
  "Evusheld": "tixagevimab_cilgavimab",
  "HER3-DXd": "patritumab_deruxtecan",
  "Hemgenix": "etranacogene_deparvovec",
  "JNJ-6379": "jnj_6379",
  "L-谷氨酰胺口服粉剂": "l_glutamine_powder",
  "Lutathera": "lu177_vipivotide_tetraxetan",
  "Lyfgenia": "lyfgenia",
  "Mounjaro": "tirzepatide",
  "Padcev": "enfortumab_vedotin",
  "Pluvicto": "pluvicto",
  "REGEN-COV": "casirivimab_imdevimab",
  "Regdanvimab": "regdanvimab",
  "Sotrovimab": "sotrovimab",
  "T-DM1": "ado_trastuzumab_emtansine",
  "Teliso-V": "telisotuzumab_vedotin",
  "Tivdak": "tisotumab_vedotin",
  "Trikafta/Kaftrio": "elexacaftor_tezacaftor_ivacaftor",
  "Trodelvy": "sacituzumab_govitecan",
  "Ulotaront": "ulotaront",
  "VIR-2218": "vir_2218",
  "ValRoxo": "valoctocog_roxall",
  "Zynlonta": "loncastuximab_tesirine",
  "Zynteglo": "betibeglogene_autotemcel",
  "axi-cel": "axicabtagene_ciloleucel",
  "fidanacogene elaparvovec": "fidanacogene_elaparvovec",
  "idecel": "idecel",
  "liso-cel": "lisocabtagene_maraleucel",
  "phentermine托吡酯": "phentermine_topiramate",
  "sarecycline": "sarecycline",
  "tecarta": "brexucabtagene_autoleucel",
  "tisagenlecleucel": "tisagenlecleucel",
  "ω-3脂肪酸乙酯": "omega_3_acid_ethyl_esters",
  "丁双胍": "buformin",
  "丁螺环酮": "buspirone",
  "丙戊酸": "valproic_acid",
  "丙戊酸盐": "valproate",
  "丝裂霉素C": "mitomycin_c",
  "乌司奴单抗": "ustekinumab",
  "乌地那非": "udenafil",
  "乌布利西": "umbralisib",
  "乌布吉潘": "ubrogepant",
  "乌帕替尼": "upadacitinib",
  "乌美溴铵": "umeclidinium",
  "乐伐替尼": "lenvatinib",
  "乐卡地平": "lercanidipine",
  "乙醇酸": "glycolic acid",
  "乳酸": "lactic acid",
  "二甲双胍": "metformin",
  "亚胺培南/瑞来巴坦": "imipenem_relebactam",
  "亮丙瑞林": "leuprolide",
  "他克莫司": "tacrolimus",
  "他卡西醇": "tacalcitol",
  "他司美琼": "tasimelteon",
  "他司鲁肽": "taspoglutide",
  "他扎罗汀": "tazarotene",
  "他拉唑帕利": "talazoparib",
  "他泽美司他": "tazemetostat",
  "他达拉非": "tadalafil",
  "他达拉非(肺高压)": "tadalafil_pah",
  "他非诺喹": "tafenoquine",
  "伊伐布雷定": "ivabradine",
  "伊匹木单抗": "ipilimumab",
  "伊夫加替莫德": "efgartigimod",
  "伊布替尼": "ibrutinib",
  "伊拉地平": "isradipine",
  "伊斯特拉德菲": "istradefylline",
  "伊斯特拉韦": "islatravir",
  "伊普格列净": "ipragliflozin",
  "伊沙佐米": "ixazomib",
  "伊洛前列素": "iloprost",
  "伊潘立酮": "iloperidone",
  "伊维珠单抗": "ivekizumab",
  "伊马替尼": "imatinib",
  "伏环孢素": "voclosporin",
  "伏立诺他": "vorinostat",
  "伏美替尼": "furmonertinib",
  "伐地那非": "vardenafil",
  "伐地那非(肺高压)": "vardenafil_pah",
  "伐昔洛韦": "valacyclovir",
  "伦卡帕韦": "lenacapavir",
  "佐匹克隆": "zopiclone",
  "佩米替尼": "pemazyre",
  "佩费替尼": "peficitinib",
  "依伐卡托": "ivacaftor",
  "依前列醇": "epoprostenol",
  "依匹哌唑": "brexpiprazole",
  "依卢多林": "eluxadoline",
  "依奇珠单抗": "ixekizumab",
  "依库珠单抗": "eculizumab",
  "依托考昔": "etoricoxib",
  "依拉环素": "eravacycline",
  "依普沙坦": "eprosartan",
  "依来卡托": "elexacaftor",
  "依沃列汀": "evogliptin",
  "依洛尤单抗": "evolocumab",
  "依维莫司": "everolimus",
  "依诺肝素": "enoxaparin",
  "依达拉奉": "edaravone",
  "依那普利": "enalapril",
  "依那西普": "etanercept",
  "信迪利单抗": "sintilimab",
  "倍他米松": "betamethasone",
  "克唑替尼": "crizotinib",
  "克拉屈滨": "cladribine",
  "克林霉素": "clindamycin",
  "克立硼罗": "crisaborole",
  "克立赞珠单抗": "crizanlizumab",
  "克罗非莫": "crofelemer",
  "克雷诺拉尼": "crenolanib",
  "兰尼布诺": "lanifibranor",
  "兰索拉唑": "lansoprazole",
  "决奈达隆": "dronedarone",
  "利伐沙班": "rivaroxaban",
  "利匹韦林": "rilpivirine",
  "利培酮": "risperidone",
  "利塞膦酸": "risedronate",
  "利奈唑胺": "linezolid",
  "利奥西呱": "riociguat",
  "利妥昔单抗": "rituximab",
  "利巴韦林": "ribavirin",
  "利托那韦": "ritonavir",
  "利拉鲁肽": "liraglutide",
  "利拉鲁肽注射液(减重)": "liraglutide_weight",
  "利斯的明": "rivastigmine",
  "利格列汀": "linagliptin",
  "利格列汀二甲双胍": "linagliptin_metformin",
  "利福昔明": "rifaximin",
  "利西拉来": "lixisenatide",
  "利那洛肽": "linaclotide",
  "利鲁唑": "riluzole",
  "别嘌醇": "allopurinol",
  "加兰他敏": "galantamine",
  "加卡奈珠单抗": "galcanezumab",
  "加奈索龙": "ganaxolone",
  "加巴喷丁": "gabapentin",
  "加巴喷丁酯": "gabapentin_enacarbil",
  "加拉达昔单抗": "garadacimab",
  "劳拉替尼": "lorlatinib",
  "劳拉西泮": "lorazepam",
  "勒卡尼单抗": "lecanemab",
  "匹伐他汀": "pitavastatin",
  "匹妥布鲁替尼": "pirtobrutinib",
  "匹莫范色林": "pimavanserin",
  "半胱胺比特塔尔": "cysteamine_bitartrate",
  "华法林": "warfarin",
  "卡介苗": "bcg",
  "卡利拉嗪": "cariprazine",
  "卡博替尼": "cabozantinib",
  "卡博特韦": "cabotegravir",
  "卡巴他赛": "cabazitaxel",
  "卡度尼利单抗": "cadonilimab",
  "卡托普利": "captopril",
  "卡格列净": "canagliflozin",
  "卡格列净二甲双胍": "canagliflozin_metformin",
  "卡泊三醇": "calcipotriol",
  "卡瑞利珠单抗": "camrelizumab",
  "卡纳单抗": "canakinumab",
  "卡铂": "carboplatin",
  "卡马替尼": "capmatinib",
  "卡马西平": "carbamazepine",
  "卢卡帕利": "rucaparib",
  "卢塞格列净": "luseogliflozin",
  "卢美哌隆": "lumateperone",
  "卢非酰胺": "rufinamide",
  "厄洛替尼": "erlotinib",
  "厄瑞奴单抗": "erenumab",
  "厄贝沙坦": "irbesartan",
  "厄达替尼": "erdafitinib",
  "去氨加压素": "desmopressin",
  "双氢青蒿素/哌喹": "dihydroartemisinin_piper",
  "双氯芬酸": "diclofenac",
  "古塞奇尤单抗": "guselkumab",
  "可乐定": "clonidine",
  "右佐匹克隆": "eszopiclone",
  "右兰索拉唑": "dexlansoprazole",
  "司替戊醇": "stiripentol",
  "司来吉兰": "selegiline",
  "司美拉诺肽": "setmelanotide",
  "司美格鲁肽": "semaglutide",
  "司美格鲁肽(NASH)": "semaglutide_nash",
  "司美格鲁肽注射液": "semaglutide_injection",
  "吉格列汀": "gemigliptin",
  "吉瑞替尼": "gilteritinib",
  "吉西他滨": "gemcitabine",
  "吉非替尼": "gefitinib",
  "吉非罗齐": "gemfibrozil",
  "吗替麦考酚": "mycophenolate",
  "吡仑帕奈": "perampanel",
  "吡咯替尼": "pyrotinib",
  "吡拉西坦": "piracetam",
  "吡格列酮": "pioglitazone",
  "吡格列酮二甲双胍": "pioglitazone_metformin",
  "吡美莫司": "pimecrolimus",
  "吡非尼酮": "pirfenidone",
  "吸入用妥布霉素": "tobramycin_inhalation",
  "吸入用左氧氟沙星": "levofloxacin_inhalation",
  "吸入用氨曲南": "aztreonam_inhalation",
  "吸入用粘菌素甲磺酸钠": "colistimethate_inhalation",
  "呋喹替尼": "fruquintinib",
  "呫诺美林": "xanomeline",
  "呫诺美林/曲司氯铵": "xanomeline_trospium_chloride",
  "呫诺美林曲司氯铵": "xanomeline_trospium_chloride",
  "咕诺美林": "xanomeline",
  "咕诺美林/曲司氯铵": "xanomeline_trospium_chloride",
  "咕诺美林曲司氯铵": "xanomeline_trospium_chloride",
  "咪达普利": "imidapril",
  "哌仑他韦": "pibrentasvir",
  "哌唑嗪": "prazosin",
  "哌柏西利": "palbociclib",
  "唑吡坦": "zolpidem",
  "唑尼沙胺": "zonisamide",
  "唑来膦酸": "zoledronate",
  "喜得镇": "hydergine",
  "喹硫平": "quetiapine",
  "喹那普利": "quinapril",
  "噻吗洛尔": "timolol",
  "噻托溴铵": "tiotropium",
  "图卡替尼": "tucatinib",
  "地加瑞克": "degarelix",
  "地塞米松": "dexamethasone",
  "地奈德": "desonide",
  "地尔硫卓": "diltiazem",
  "地舒单抗": "denosumab",
  "地芬诺酯/阿托品": "diphenoxylate_atropine",
  "地西泮": "diazepam",
  "坎地沙坦": "candesartan",
  "坎格瑞洛": "cangrelor",
  "坦索罗辛": "tamsulosin",
  "埃万妥单抗": "amivantamab",
  "埃普奈珠单抗": "eptinezumab",
  "埃曲西莫德": "etrasimod",
  "埃维纳库单抗": "evinacumab",
  "培哚普利": "perindopril",
  "培米替尼": "pemigatinib",
  "培马贝特": "pemafibrate",
  "塞利尼索": "selinexor",
  "塞利曲替尼": "selitrectinib",
  "塞尔帕替尼": "selpercatinib",
  "塞尼西罗韦": "cenicriviroc",
  "塞替派": "thiotepa",
  "塞来昔布": "celecoxib",
  "壬二酸": "azelaic acid",
  "外周作用μ受体拮抗剂": "peripherally_acting_mu_opioid_antagonists",
  "多佐胺": "dorzolamide",
  "多塔利单抗": "dostarlimab",
  "多奈哌齐": "donepezil",
  "多拉韦林": "doravirine",
  "多柔比星": "doxorubicin",
  "多沙唑嗪": "doxazosin",
  "多纳单抗": "donanemab",
  "多纳非尼": "donafenib",
  "多西他赛": "docetaxel",
  "多西环素": "doxycycline",
  "多韦替尼": "dovitinib",
  "头孢他啶/阿维巴坦": "ceftazidime_avibactam",
  "头孢克肟": "cefotaxime",
  "头孢地尔": "cefiderocol",
  "头孢曲松": "ceftriaxone",
  "头孢洛扎/他唑巴坦": "ceftolozane_tazobactam",
  "奈拉替尼": "neratinib",
  "奈玛特韦/利托那韦(Paxlovid)": "nirmatrelvir_ritonavir",
  "奈莫利珠单抗": "nemolizumab",
  "奈非西坦": "nefiracetam",
  "奎扎替尼": "quizartinib",
  "奥佩康唑": "opelconazole",
  "奥利司他": "orlistat",
  "奥匹哌醇": "opipramol",
  "奥卡西平": "oxcarbazepine",
  "奥司他韦": "oseltamivir",
  "奥妥珠单抗": "obinutuzumab",
  "奥希替尼": "osimertinib",
  "奥德维昔巴特": "odevixibat",
  "奥扎尼莫德": "ozanimod",
  "奥拉帕利": "olaparib",
  "奥拉西坦": "oxiracetam",
  "奥昔布宁": "oxybutynin",
  "奥比他韦": "ombitasvir",
  "奥比他韦/帕利瑞韦/利托那韦": "ombitasvir_paritaprevir_ritonavir",
  "奥氮平": "olanzapine",
  "奥沙拉嗪": "olsalazine",
  "奥法木单抗": "ofatumumab",
  "奥洛罗芬": "olorofim",
  "奥瑞珠单抗": "ocrelizumab",
  "奥皮卡朋": "opicapone",
  "奥美卡替美卡比": "omecamtiv_mecarbil",
  "奥美拉唑": "omeprazole",
  "奥美沙坦": "olmesartan",
  "奥贝胆酸": "obeticholic_acid",
  "奥雷巴替尼": "orelabrutinib",
  "奥马环素": "omadacycline",
  "奥马珠单抗": "omalizumab",
  "奥鲁塔西地尼": "olutasidenib",
  "孟鲁司特": "montelukast",
  "安立生坦": "ambrisentan",
  "安罗替尼": "anlotinib",
  "安非他酮": "bupropion",
  "安非他酮/纳曲酮复方": "bupropion_naltrexone",
  "安非他酮naltrexone": "bupropion_naltrexone",
  "富马酸二甲酯": "dimethyl_fumarate",
  "对乙酰氨基酚": "acetaminophen",
  "尼卡地平": "nicardipine",
  "尼拉帕利": "niraparib",
  "尼洛替尼": "nilotinib",
  "尼群地平": "nitrendipine",
  "尼达尼布": "nintedanib",
  "左乙拉西坦": "levetiracetam",
  "左氧氟沙星": "levofloxacin",
  "左甲状腺素": "levothyroxine",
  "左美丙米嗪": "levomilnacipran",
  "巴柳氮": "balsalazide",
  "巴瑞替尼": "baricitinib",
  "布吉他滨": "brigatinib",
  "布地奈德": "budesonide",
  "布地奈德(IBD)": "budesonide_ibd",
  "布地奈德肠溶胶囊(IgA肾病)": "budesonide_iga",
  "布来韦肽": "bulevirtide",
  "布林佐胺": "brinzolamide",
  "布洛芬": "ibuprofen",
  "布瓦西坦": "brivaracetam",
  "布达鲁单抗": "brodalumab",
  "帕克里替尼": "pacritinib",
  "帕利哌酮": "paliperidone",
  "帕利瑞韦": "paritaprevir",
  "帕博利珠单抗": "pembrolizumab",
  "帕唑帕尼": "pazopanib",
  "帕妥珠单抗": "pertuzumab",
  "帕拉米韦": "peramivir",
  "帕比司他": "panobinostat",
  "帕罗西汀": "paroxetine",
  "帕萨克利西": "parsaclisib",
  "干扰素α": "interferon_alfa",
  "库潘尼西": "copanlisib",
  "度他雄胺": "dutasteride",
  "度伐利尤单抗": "durvalumab",
  "度恩利西": "duvelisib",
  "度拉糖肽": "dulaglutide",
  "度普利尤单抗": "dupilumab",
  "度洛西汀": "duloxetine",
  "异丙托溴铵": "ipratropium",
  "异维A酸": "isotretinoin",
  "弗瑞奈珠单抗": "fremanezumab",
  "德卡伐替尼": "deucravacitinib",
  "德尔戈替尼": "delgocitinib",
  "德拉沙星": "delafloxacin",
  "德拉马尼": "delamanid",
  "恩他卡朋": "entacapone",
  "恩曲替尼": "entrectinib",
  "恩杂鲁胺": "enzalutamide",
  "恩格列净": "empagliflozin",
  "恩格列净二甲双胍": "empagliflozin_metformin",
  "恩沃利单抗": "envafolimab",
  "恩沙替尼": "ensartinib",
  "恩考芬尼": "encorafenib",
  "恩西地平": "enasidenib",
  "戈利木单抗": "golimumab",
  "戈舍瑞林": "goserelin",
  "扁桃酸": "mandelic acid",
  "扎尼单抗": "zanimivab",
  "扎维吉潘": "zavegepant",
  "托吡酯": "topiramate",
  "托夫生": "tofersen",
  "托格列净": "tofogliflozin",
  "托法替尼": "tofacitinib",
  "托特罗定": "tolterodine",
  "托珠单抗": "tocilizumab",
  "托莫西汀": "atomoxetine",
  "抗坏血酸": "ascorbic acid",
  "拉坦前列素": "latanoprost",
  "拉多斯蒂吉": "ladostigil",
  "拉尼纳米韦": "laninamivir",
  "拉帕替尼": "lapatinib",
  "拉斯米地坦": "lasmiditan",
  "拉武利珠单抗": "ravulizumab",
  "拉罗替尼": "larotrectinib",
  "拉考酰胺": "lacosamide",
  "拉莫三嗪": "lamotrigine",
  "拉西地平": "lacidipine",
  "提德拉珠单抗": "tildrakizumab",
  "文拉法辛": "venlafaxine",
  "斯佩利珠单抗": "spesolimab",
  "昂丹司琼": "ondansetron",
  "普伐他汀": "pravastatin",
  "普卡那肽": "plecanatide",
  "普托马尼": "pretomanid",
  "普拉克索": "pramipexole",
  "普拉替尼": "pralsetinib",
  "普拉格雷": "prasugrel",
  "普拉西坦": "pramiracetam",
  "普瑞巴林": "pregabalin",
  "普罗利珠单抗": "prolgolimab",
  "普罗维韦": "propiverine",
  "普芦卡必利": "prucalopride",
  "曲前列素": "treprostinil",
  "曲司氯铵": "trospium_chloride",
  "曲唑酮": "trazodone",
  "曲妥珠单抗": "trastuzumab",
  "曲安奈德": "triamcinolone",
  "曲拉西利": "trilaciclib",
  "曲普瑞林": "triptorelin",
  "曲罗金单抗": "tralokinumab",
  "曲美替尼": "trametinib",
  "曲酸": "kojic acid",
  "曼尼地平": "manidipine",
  "替万替尼": "tivantinib",
  "替妥木单抗": "teprotumumab",
  "替尔泊肽": "tirzepatide",
  "替尼格列汀": "teneligliptin",
  "替拉布鲁替尼": "tirabrutinib",
  "替格列汀": "teneligliptin",
  "替格列汀片": "teneligliptin",
  "替格瑞洛": "ticagrelor",
  "替米沙坦": "telmisartan",
  "替米沙坦氢氯噻嗪": "telmisartan_hydrochlorothiazide",
  "替米沙坦氨氯地平": "telmisartan_amlodipine",
  "替纳帕诺": "tenapanor",
  "替西罗莫司": "temsirolimus",
  "替诺福韦艾拉酚胺": "tenofovir_alafenamide",
  "替雷利珠单抗": "tislelizumab",
  "本瑞利珠单抗": "benralizumab",
  "来布里珠单抗": "lebrikizumab",
  "来法米林": "lefamulin",
  "来迪派韦": "ledipasvir",
  "来迪派韦/索磷布韦": "ledipasvir_sofosbuvir",
  "来那度胺": "lenalidomide",
  "林普利西": "linperlisib",
  "柳氮磺吡啶": "sulfasalazine",
  "格列列汀": "gergliptin",
  "格列吡嗪": "glipizide",
  "格列喹酮": "gliquidone",
  "格列本脲": "glyburide",
  "格列本脲二甲双胍": "glyburide_metformin",
  "格列美脲": "glimepiride",
  "格列美脲二甲双胍": "glimepiride_metformin",
  "格列美醇": "glimepirone",
  "格列苯脲": "glyburide",
  "格列齐特": "gliclazide",
  "格卡瑞韦": "glecaprevir",
  "格卡瑞韦/哌仑他韦": "glecaprevir_pibrentasvir",
  "格拉瑞韦": "grazoprevir",
  "格隆溴铵": "glycopyrronium",
  "比克替拉韦": "bictegravir",
  "比索洛尔": "bisoprolol",
  "比美替尼": "binimetinib",
  "比美珠单抗": "bimekizumab",
  "氟他胺": "flutamide",
  "氟伐他汀": "fluvastatin",
  "氟哌啶醇": "haloperidol",
  "氟替卡松": "fluticasone",
  "氟西汀": "fluoxetine",
  "氟轻松": "fluocinolone",
  "氢化可的松": "hydrocortisone",
  "氢氯噻嗪": "hydrochlorothiazide",
  "氢溴酸替尼格列汀": "teneligliptin",
  "氢溴酸替尼格列汀片": "teneligliptin",
  "氢溴酸替格列汀": "teneligliptin",
  "氢溴酸替格列汀片": "teneligliptin",
  "氨曲南": "aztreonam",
  "氨曲南/阿维巴坦": "aztreonam_avibactam",
  "氨氯地平": "amlodipine",
  "氨氯地平替米沙坦": "telmisartan_amlodipine",
  "氨氯地平替米沙坦片": "telmisartan_amlodipine",
  "氨甲环酸": "tranexamic acid",
  "氨苯砜": "dapsone",
  "氯丙嗪": "chlorpromazine",
  "氯倍他索": "clobetasol",
  "氯吡格雷": "clopidogrel",
  "氯氮平": "clozapine",
  "氯沙坦": "losartan",
  "氯硝西泮": "clonazepam",
  "氯胺酮": "ketamine",
  "水杨酸": "salicylic acid",
  "沃塞洛托": "voxelotor",
  "沃昔拉韦": "voxilaprevir",
  "沃替西汀": "vortioxetine",
  "沙丁胺醇": "salbutamol",
  "沙利鲁单抗": "sarilumab",
  "沙库巴曲": "sacubitril",
  "沙库巴曲缬沙坦": "sacubitril_valsartan",
  "沙格列汀": "saxagliptin",
  "沙美特罗": "salmeterol",
  "沙芬酰胺": "safinamide",
  "泊马度胺": "pomalidomide",
  "法匹拉韦": "favipiravir",
  "法索西坦": "fasoracetam",
  "波内西莫德": "ponesimod",
  "波生坦": "bosentan",
  "泮托拉唑": "pantoprazole",
  "泼尼卡酯": "prednicarbate",
  "泼尼松": "prednisone",
  "泼尼松龙": "prednisolone",
  "泽布替尼": "zanubrutinib",
  "洛伐他汀": "lovastatin",
  "洛哌丁胺": "loperamide",
  "洛那帕生长素": "lonapegsomatropin",
  "海曲泊帕": "hetrombopag",
  "消旋卡多曲": "racecadotril",
  "淀粉酶": "amylase",
  "熊去氧胆酸": "ursodeoxycholic_acid",
  "特扎卡托": "tezacaftor",
  "特扎卡托/依伐卡托": "tezacaftor_ivacaftor",
  "特拉唑嗪": "terazosin",
  "特泊替尼": "tepotinib",
  "特泽鲁单抗": "tezepelumab",
  "特瑞普利单抗": "toripalimab",
  "特立氟胺": "teriflunomide",
  "玛巴洛沙韦": "baloxavir_marboxil",
  "玛格妥昔单抗": "margetuximab",
  "环丙沙星": "ciprofloxacin",
  "环丙贝特": "ciprofibrate",
  "环孢素": "cyclosporine",
  "瑞利珠单抗": "reslizumab",
  "瑞博西利": "ribociclib",
  "瑞卢戈利": "relugolix",
  "瑞德西韦": "remdesivir",
  "瑞戈非尼": "regorafenib",
  "瑞扎芬净": "rezafungin",
  "瑞普替尼": "repotrectinib",
  "瑞替加宾": "retigabine",
  "瑞波西汀": "reboxetine",
  "瑞派替尼": "ripretinib",
  "瑞维非宁": "revefenacin",
  "瑞美吉潘": "rimegepant",
  "瑞舒伐他汀": "rosuvastatin",
  "瑞赞珠单抗": "risankizumab",
  "甲基纳曲酮": "methylnaltrexone",
  "甲氧氯普胺": "metoclopramide",
  "甲氨蝶呤": "methotrexate",
  "甲泼尼龙": "methylprednisolone",
  "甲硝唑": "metronidazole",
  "甲苯磺酸卢美哌隆": "lumateperone",
  "甲苯磺酸卢美哌隆胶囊": "lumateperone",
  "白细胞介素-2": "interleukin_2",
  "盐酸丁螺环酮": "buspirone",
  "盐酸丁螺环酮片": "buspirone",
  "盐酸罗匹尼罗": "ropinirole",
  "盐酸罗匹尼罗片": "ropinirole",
  "盐酸罗匹尼罗缓释片": "ropinirole",
  "睾酮": "testosterone",
  "硝苯地平": "nifedipine",
  "硫必利": "tianeptine",
  "碱式水杨酸铋": "bismuth_subsalicylate",
  "磷酸萘酚喹/青蒿琥酯": "pyronaridine_artesunate",
  "祖鲁库单抗": "zilucoplan",
  "福他替尼": "fostamatinib",
  "福巴替尼": "futibatinib",
  "福斯左多巴": "foslevodopa",
  "福斯马诺匹克司": "fosmanogepix",
  "福替尼": "foretinib",
  "福莫司汀": "fotemustine",
  "福莫特罗": "formoterol",
  "福辛普利": "fosinopril",
  "科尔鲁西坦": "coluracetam",
  "米哚妥林": "midostaurin",
  "米托蒽醌": "mitoxantrone",
  "米拉贝隆": "mirabegron",
  "米氮平": "mirtazapine",
  "米瑞珠单抗": "mirikizumab",
  "米罗地那非": "mirodenafil",
  "米诺环素": "minocycline",
  "米那普仑": "milnacipran",
  "糠酸莫米松": "mometasone",
  "索凡替尼": "surufatinib",
  "索利亚莫非": "solriamfetol",
  "索利那新": "solifenacin",
  "索托拉西布": "sotorasib",
  "索拉非尼": "sorafenib",
  "索磷布韦": "sofosbuvir",
  "索磷布韦/维帕他韦": "sofosbuvir_velpatasvir",
  "索磷布韦/维帕他韦/ voxilaprevir": "sofosbuvir_velpatasvir_voxilaprevir",
  "索马帕太坦": "somapacitan",
  "索马曲甘": "somatrogon",
  "红霉素": "erythromycin",
  "纳地美定": "naldemedine",
  "纳武利尤单抗": "nivolumab",
  "纳洛西格": "naloxegol",
  "组胺瑞林": "histrelin",
  "维A酸": "tretinoin",
  "维利西呱": "vericiguat",
  "维多利珠单抗": "vedolizumab",
  "维奈克拉": "venetoclax",
  "维帕他韦": "velpatasvir",
  "维拉佐酮": "vilazodone",
  "维格列汀": "vildagliptin",
  "维洛沙嗪": "viloxazine",
  "维纳卡兰特": "vernakalant",
  "维贝格隆": "vibegron",
  "缬沙坦": "valsartan",
  "罗匹尼罗": "ropinirole",
  "罗卓利珠单抗": "rozanolixizumab",
  "罗地那非": "lodenafil",
  "罗替戈汀": "rotigotine",
  "罗格列酮": "rosiglitazone",
  "罗格列酮二甲双胍": "rosiglitazone_metformin",
  "罗特西普": "luspatercept",
  "罗米司亭": "romiplostim",
  "罗米地辛": "romidepsin",
  "罗鲁培酮": "roluperidone",
  "美沙拉嗪": "mesalamine",
  "美泊利单抗": "mepolizumab",
  "美洛加巴林": "mirogabalin",
  "美洛昔康": "meloxicam",
  "美罗培南/法硼巴坦": "meropenem_vaborbactam",
  "美金刚": "memantine",
  "羟嗪": "hydroxyzine",
  "群多普利": "trandolapril",
  "耐福康": "nefecon",
  "肉毒素A(Botox膀胱注射)": "onabotulinumtoxina",
  "肝素": "heparin",
  "胍法辛": "guanfacine",
  "胰脂肪酶": "pancrelipase",
  "脂肪酶": "lipase",
  "舍曲林": "sertraline",
  "舒尼替尼": "sunitinib",
  "舒格利单抗": "sugemalimab",
  "舒沃替尼": "sunvozertinib",
  "色瑞替尼": "ceritinib",
  "艾代拉里斯": "idelalisib",
  "艾伏尼布": "ivosidenib",
  "艾司利卡西平": "eslicarbazepine",
  "艾司唑仑": "estazolam",
  "艾司奥美拉唑": "esomeprazole",
  "艾司氯胺酮": "esketamine",
  "艾司西酞普兰": "escitalopram",
  "艾塞那肽": "exenatide",
  "艾多沙班": "edoxaban",
  "艾尔巴韦": "elbasvir",
  "艾尔巴韦/格拉瑞韦": "elbasvir_grazoprevir",
  "艾托格列净": "ertugliflozin",
  "艾托格列净二甲双胍": "ertugliflozin_metformin",
  "艾曲波帕": "eltrombopag",
  "艾洛昔巴特": "elobixibat",
  "艾瑞卡芬格匹": "ibrexafungerp",
  "艾美赛珠α": "efmoroctocog_alfa",
  "艾美赛珠单抗": "emicizumab",
  "芦可替尼": "ruxolitinib",
  "芬戈莫德": "fingolimod",
  "芬氟拉明": "fenfluramine",
  "芬特明/托吡酯复方": "phentermine_topiramate",
  "苏沃雷生": "suvorexant",
  "苏泰唑烷": "sutezolid",
  "苏金单抗": "secukinumab",
  "苯丁酸钠牛磺熊去氧胆酸": "sodium_phenylbutyrate_taurursodiol",
  "苯乙双胍": "phenformin",
  "苯基吡拉西坦": "phenylpiracetam",
  "苯妥英": "phenytoin",
  "苯扎贝特": "bezafibrate",
  "苯溴马隆": "benzbromarone",
  "英克西兰": "inclisiran",
  "英夫利西单抗": "infliximab",
  "茴拉西坦": "aniracetam",
  "莫博赛替尼": "mobocertinib",
  "莫西沙星": "moxifloxacin",
  "莫诺拉韦": "molnupiravir",
  "莫达非尼": "modafinil",
  "莱博雷生": "lemborexant",
  "萘普生": "naproxen",
  "萨特利珠单抗": "satralizumab",
  "蒂沃扎尼": "tivozanib",
  "蒿甲醚/苯芴醇": "artemether_lumefantrine",
  "蛋白酶": "protease",
  "表柔比星": "epirubicin",
  "西地那非": "sildenafil",
  "西地那非(肺高压)": "sildenafil_pah",
  "西尼地平": "cilnidipine",
  "西格列汀": "sitagliptin",
  "西波尼莫德": "siponimod",
  "西洛多辛": "silodosin",
  "西米普利单抗": "cemiplimab",
  "西罗莫司": "sirolimus",
  "西酞普兰": "citalopram",
  "诺匹司坦": "noopept",
  "贝伐珠单抗": "bevacizumab",
  "贝利司他": "belinostat",
  "贝利木单抗": "belimumab",
  "贝尔祖替凡": "belzutifan",
  "贝尼地平": "benidipine",
  "贝沙罗汀": "bexarotene",
  "贝派地酸": "bempedoic_acid",
  "贝美前列素": "bimatoprost",
  "贝西福韦": "besifovir_dipivoxil",
  "贝达喹啉": "bedaquiline",
  "赖右苯丙胺": "lisdexamfetamine",
  "赖诺普利": "lisinopril",
  "赛乐西帕": "selexipag",
  "赛妥珠单抗": "certolizumab",
  "赛妥珠单抗酯": "certolizumab_pegol",
  "赛帕利单抗": "serplulimab",
  "赛沃替尼": "savolitinib",
  "辛伐他汀": "simvastatin",
  "辛诺巴莫特": "cenobamate",
  "达克替尼": "dacomitinib",
  "达利度雷生": "daridorexant",
  "达卡他韦": "daclatasvir",
  "达拉非尼": "dabrafenib",
  "达格列净": "dapagliflozin",
  "达格列净二甲双胍": "dapagliflozin_metformin",
  "达比加群": "dabigatran",
  "达沙布韦/奥比他韦/帕利瑞韦/利托那韦": "dasabuvir_ombitasvir_paritapritonavir",
  "达沙替尼": "dasatinib",
  "达洛鲁胺": "darolutamide",
  "达莫库珠α聚乙二醇": "damoctocog_alfa_pegol",
  "达非那新": "darifenacin",
  "过氧化苯甲酰": "benzoyl_peroxide",
  "迪罗西麦富马酸盐": "diroximel_fumarate",
  "那他珠单抗": "natalizumab",
  "那法瑞林": "nafarelin",
  "醋酸环丙孕酮": "cyproterone",
  "链道酶α": "dornase_alfa",
  "锂盐": "lithium",
  "镭223": "radium_223",
  "长春碱": "vinblastine",
  "阿仑单抗": "alemtuzumab",
  "阿仑膦酸": "alendronate",
  "阿伐可泮": "avacopan",
  "阿伐普替尼": "avapritinib",
  "阿伐曲泊帕": "avatrombopag",
  "阿伐那非": "avanafil",
  "阿利库单抗": "alirocumab",
  "阿卡替尼": "acalabrutinib",
  "阿哌沙班": "apixaban",
  "阿地溴铵": "aclidinium",
  "阿培利司": "alpelisib",
  "阿塞那平": "asenapine",
  "阿夫唑嗪": "alfuzosin",
  "阿奇霉素": "azithromycin",
  "阿尼弗鲁单抗": "anifrolumab",
  "阿巴西普": "abatacept",
  "阿布昔替尼": "abrocitinib",
  "阿帕替尼": "apatinib",
  "阿帕鲁胺": "apalutamide",
  "阿必鲁肽": "albiglutide",
  "阿戈美拉汀": "agomelatine",
  "阿扑吗啡": "apomorphine",
  "阿托伐他汀": "atorvastatin",
  "阿托吉潘": "atogepant",
  "阿昔替尼": "axitinib",
  "阿昔洛韦": "acyclovir",
  "阿普唑仑": "alprazolam",
  "阿普斯特": "apremilast",
  "阿替利珠单抗": "atezolizumab",
  "阿杜卡努单抗": "aducanumab",
  "阿来替尼": "alectinib",
  "阿柏西普": "aflibercept",
  "阿格列汀": "alogliptin",
  "阿比特龙": "abiraterone",
  "阿法替尼": "afatinib",
  "阿立哌唑": "aripiprazole",
  "阿米西莫德": "amiselimod",
  "阿维A": "acitretin",
  "阿维鲁单抗": "avelumab",
  "阿美替尼": "almonertinib",
  "阿舒那韦": "asunaprevir",
  "阿莫西林": "amoxicillin",
  "阿莫达非尼": "armodafinib",
  "阿贝西利": "abemaciclib",
  "阿达帕林": "adapalene",
  "阿达木单抗": "adalimumab",
  "阿达格拉西布": "adagrasib",
  "阿那白滞素": "anakinra",
  "阿魏酸": "ferulic acid",
  "阿齐沙坦": "azilsartan",
  "雌二醇": "estradiol",
  "雌莫司汀": "estramustine",
  "雷尔德塞姆替夫": "reldesemtiv",
  "雷斯美替罗": "resmetirom",
  "雷沙吉兰": "rasagiline",
  "雷米普利": "ramipril",
  "雷美替胺": "ramelteon",
  "雷莫格列净": "remogliflozin",
  "雷莫芦单抗": "ramucirumab",
  "雷贝拉唑": "rabeprazole",
  "青蒿琥酯/阿莫地喹": "artesunate_amodiaquine",
  "非卓替尼": "fedratinib",
  "非布司他": "febuxostat",
  "非戈替尼": "filgotinib",
  "非洛地平": "felodipine",
  "非索罗定": "fesoterodine",
  "非诺贝特": "fenofibrate",
  "非那雄胺": "finasteride",
  "顺铂": "cisplatin",
  "马克沙钙醇": "maxacalcitol",
  "马利昔巴特": "maralixibat",
  "马斯塔昔单抗": "marstacimab",
  "马昔腾坦": "macitentan",
  "马诺匹克司": "manogepix",
  "骨化三醇": "calcitriol",
  "鲁比前列酮": "lubiprostone",
  "鲁美哌隆": "lumateperone",
  "鲁马卡托": "lumacaftor",
  "鹅去氧胆酸": "chenodeoxycholic_acid",
  "黄体酮": "progesterone",
  "齐拉西酮": "ziprasidone"
};

export const EXTENDED_BRAND_TO_INN: Record<string, string> = {
  "5-asa": "mesalamine",
  "aceon": "perindopril",
  "aciphex": "rabeprazole",
  "adalat": "nifedipine",
  "advil": "ibuprofen",
  "aleve": "naproxen",
  "altace": "ramipril",
  "amoxil": "amoxicillin",
  "apriso": "mesalamine",
  "asacol": "mesalamine",
  "atacand": "candesartan",
  "avapro": "irbesartan",
  "avastin": "bevacizumab",
  "avelox": "moxifloxacin",
  "azilect": "rasagiline",
  "azulfidine": "sulfasalazine",
  "bavencio": "avelumab",
  "benicar": "olmesartan medoxomil",
  "brilinta": "ticagrelor",
  "bydureon": "exenatide",
  "byetta": "exenatide",
  "calquence": "acalabrutinib",
  "canasa": "mesalamine",
  "caplyta": "lumateperone",
  "capoten": "captopril",
  "cardizem": "diltiazem",
  "cataflam": "diclofenac",
  "celebrex": "celecoxib",
  "celexa": "citalopram",
  "cipro": "ciprofloxacin",
  "claversal": "mesalamine",
  "cobenfy": "xanomeline_trospium_chloride",
  "comtan": "entacapone",
  "concor": "bisoprolol",
  "coumadin": "warfarin",
  "cozaar": "losartan",
  "crestor": "rosuvastatin",
  "cymbalta": "duloxetine",
  "deltasone": "prednisone",
  "delzicol": "mesalamine",
  "depakote": "valproic_acid",
  "diovan": "valsartan",
  "doryx": "doxycycline",
  "dupixent": "dupilumab",
  "effexor": "venlafaxine",
  "effient": "prasugrel",
  "eliquis": "apixaban",
  "enbrel": "etanercept",
  "entocort": "budesonide",
  "entresto": "sacubitril_valsartan",
  "farxiga": "dapagliflozin",
  "fasenra": "benralizumab",
  "flagyl": "metronidazole",
  "fortamet": "metformin",
  "forxiga": "dapagliflozin",
  "galvus": "vildagliptin",
  "gleevec": "imatinib",
  "glucophage": "metformin",
  "glumetza": "metformin",
  "herceptin": "trastuzumab",
  "humira": "adalimumab",
  "ibrance": "palbociclib",
  "imbruvica": "ibrutinib",
  "imfinzi": "durvalumab",
  "invokana": "canagliflozin",
  "iressa": "gefitinib",
  "jantoven": "warfarin",
  "janumet": "sitagliptin",
  "januvia": "sitagliptin",
  "jardiance": "empagliflozin",
  "jentadueto": "linagliptin_metformin",
  "jentadueto xr": "linagliptin_metformin",
  "karxt": "xanomeline_trospium_chloride",
  "keppra": "levetiracetam",
  "keytruda": "pembrolizumab",
  "kisqali": "ribociclib",
  "lamictal": "lamotrigine",
  "lescol": "fluvastatin",
  "levaquin": "levofloxacin",
  "levoxyl": "levothyroxine",
  "lexapro": "escitalopram",
  "lialda": "mesalamine",
  "libtayo": "cemiplimab",
  "lipitor": "atorvastatin",
  "livalo": "pitavastatin",
  "lixiana": "edoxaban",
  "lonitab": "lacidipine",
  "lumigan": "bimatoprost",
  "lynparza": "olaparib",
  "lyrica": "pregabalin",
  "medrol": "methylprednisolone",
  "mesalazine": "mesalamine",
  "mesasal": "mesalamine",
  "mevacor": "lovastatin",
  "micardis": "telmisartan",
  "mirapex": "pramipexole",
  "mirapex er": "pramipexole",
  "motrin": "ibuprofen",
  "mounjaro": "tirzepatide",
  "naprosyn": "naproxen",
  "nesina": "alogliptin",
  "neupro": "rotigotine",
  "neurontin": "gabapentin",
  "nexium": "esomeprazole",
  "norvasc": "amlodipine",
  "nucala": "mepolizumab",
  "onglyza": "saxagliptin",
  "opdivo": "nivolumab",
  "ozempic": "semaglutide",
  "panadol": "acetaminophen",
  "paxil": "paroxetine",
  "pentasa": "mesalamine",
  "plavix": "clopidogrel",
  "plendil": "felodipine",
  "pradaxa": "dabigatran",
  "pravachol": "pravastatin",
  "prednisone": "prednisone",
  "prestalia": "perindopril",
  "prevacid": "lansoprazole",
  "prilosec": "omeprazole",
  "prinivil": "lisinopril",
  "procardia": "nifedipine",
  "protonix": "pantoprazole",
  "prozac": "fluoxetine",
  "remeron": "mirtazapine",
  "remicade": "infliximab",
  "renitec": "enalapril",
  "requip": "ropinirole",
  "requip xl": "ropinirole",
  "revlimid": "lenalidomide",
  "rituxan": "rituximab",
  "rocephin": "ceftriaxone",
  "rowasa": "mesalamine",
  "rybelsus": "semaglutide",
  "salofalk": "mesalamine",
  "sanctura": "trospium_chloride",
  "savaysa": "edoxaban",
  "siofor": "metformin",
  "steglatro": "ertugliflozin",
  "stelara": "ustekinumab",
  "synthroid": "levothyroxine",
  "talzenna": "talazoparib",
  "tamiflu": "oseltamivir",
  "tarceva": "erlotinib",
  "tavanic": "levofloxacin",
  "tecentriq": "atezolizumab",
  "tegretol": "carbamazepine",
  "tenelia": "teneligliptin",
  "tradjenta": "linagliptin",
  "trajenta": "linagliptin",
  "trimox": "amoxicillin",
  "trulicity": "dulaglutide",
  "tylenol": "acetaminophen",
  "uceris": "budesonide",
  "valtrex": "valacyclovir",
  "vasotec": "enalapril",
  "venclexta": "venetoclax",
  "verzenio": "abemaciclib",
  "vibramycin": "doxycycline",
  "victoza": "liraglutide",
  "voltaren": "diclofenac",
  "wegovy": "semaglutide",
  "wellbutrin": "bupropion",
  "xadago": "safinamide",
  "xalacom": "latanoprost_timolol",
  "xalatan": "latanoprost",
  "xarelto": "rivaroxaban",
  "xofluza": "baloxavir marboxil",
  "xolair": "omalizumab",
  "xr": "sitagliptin",
  "z-pak": "azithromycin",
  "zanidip": "lercanidipine",
  "zejula": "niraparib",
  "zestril": "lisinopril",
  "zithromax": "azithromycin",
  "zocor": "simvastatin",
  "zoloft": "sertraline",
  "zyban": "bupropion"
};
